import { useEffect, useRef, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetCategoriesBlogData } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { categoriesBolgColumns } from "../../lib/definitions";
import { deleteCategoriesBlogForm } from "../../lib/actions";
import DeleteRecord from "../../ui/Models/deleteRecord";
import Pagination from "../../ui/paginations/Paginations";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import i18n from "../../lib/i18n";


export default function CategoriesBlog() {

    const [categoriesData, setCategoriesData] = useState([]);
    const deleteRef = useRef(null);
    const [currentPage, setcurrentPage] = useState(1);
    const [last_page, setlast_page] = useState(1);
    const [deleteConfirmation, setDeleteConfirmation] = useState({ isOpen: false, idToDelete: null });
    const [isLoading, setIsLoading] = useState(true);  
    const [loadingDelete, setLoadingDelete] = useState(false);  
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [currentPage])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
            deleteRef.current && 
            !deleteRef.current.contains(event.target)
            ) {
            closeDeleteConfirmation();
            }
        };

        if (deleteConfirmation.isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [deleteConfirmation.isOpen]);

    const handleApi = async () => {
        setIsLoading(true); 
        const categoriesData = await GetCategoriesBlogData(currentPage);
        setCategoriesData([]);
        setcurrentPage(categoriesData.pagination.current_page);
        setlast_page(categoriesData.pagination.last_page);
        categoriesData.data.map((e) => setCategoriesData((prev) => [...prev, e]));
        setIsLoading(false);  
    };

    const handlePageChange = (page) => {
        setcurrentPage(page);
    };

    const openDeleteConfirmation = (id) => {
        setDeleteConfirmation({ isOpen: true, idToDelete: id });
    };

    const closeDeleteConfirmation = () => {
        setDeleteConfirmation({ isOpen: false, idToDelete: null });
    };

    const handelDelete = async () => {
        if (deleteConfirmation.idToDelete) {
            setLoadingDelete(true);
            const result = await deleteCategoriesBlogForm(deleteConfirmation.idToDelete);
            if (result) {
                setLoadingDelete(false);
                handleApi();
            }
            closeDeleteConfirmation();
        }
    };

    return (
        <div className="p-8 sm:p-6 md:p-8">
            <div className="flex flex-col sm:flex-row sm:items-baseline bg-thirdly  justify-between px-5 py-5  gap-4">
                <h1 className="text-white text-lg ">{t("nav.blog_categories")}</h1>
                <Button background="#D36300" borderRadius="8px" color="white" padding="8px 20px" text={t("button.add_categories")}  nav={"/blog/categories/add"}  />
            </div>
            <div>
                {isLoading ? <TableSkeleton cols={categoriesBolgColumns}/> : (  
                    <Table columns={categoriesBolgColumns} rows={categoriesData} openDeleteConfirmation={openDeleteConfirmation} edit="/blog/categories/edit" />
                )}
            </div>
            <div className="flex justify-center items-center py-5">
                <Pagination currentPage={currentPage} totalPages={last_page} handleChangePage={handlePageChange} />
            </div>
            {deleteConfirmation.isOpen && <DeleteRecord ref={deleteRef} loadingDelete={loadingDelete} handelDelete={handelDelete} closeDeleteConfirmation={closeDeleteConfirmation} />}
        </div>
    );
};